import React from "react";
import { Link, useParams } from "react-router-dom";
import { findProgramme } from "./departments/programmeIndex";

const normalizeDownload = (item, fallbackTitle) => ({
  title: item.title || item.label || fallbackTitle,
  href: item.href || "#",
});

const getDepartmentReports = (dept) => {
  const reports = dept.newsEvents?.reports || dept.reports || [];
  return reports.map((report, index) =>
    normalizeDownload(report, `${dept.short || dept.name} Report ${index + 1}`)
  );
};

const DepartmentNewsEvents = () => {
  const { id } = useParams();
  const dept = findProgramme(id);

  if (!dept) {
    return (
      <main className="max-w-3xl mx-auto px-6 py-24 min-h-[55vh]">
        <p className="text-brand text-xl">Department page not found.</p>
        <Link to="/academics" className="inline-flex items-center gap-2 text-brand underline mt-3">
          Back to Academics
        </Link>
      </main>
    );
  }

  const reports = getDepartmentReports(dept);

  return (
    <main className="max-w-5xl mx-auto px-6 lg:px-10 py-12 min-h-[55vh]">
      <h1
        className="text-3xl md:text-4xl text-brand font-semibold mb-6"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        NEWS AND REPORT
      </h1>

      <div className="space-y-3 text-left">
        {reports.map((report) => (
          <a
            key={report.title}
            href={report.href}
            className="block text-[#2a2a2a] hover:text-brand hover:underline"
          >
            {report.title}
          </a>
        ))}
      </div>

      <Link
        to={`/programme/${dept.id}`}
        className="inline-flex items-center justify-center mt-8 bg-brand text-white px-4 py-2 text-sm font-semibold hover:bg-brand-dark transition"
      >
        Back to Program
      </Link>
    </main>
  );
};

export default DepartmentNewsEvents;
